// extracted by mini-css-extract-plugin
module.exports = {"container":"UserAdd_container__LwYoX","box":"UserAdd_box__30Yfa"};